var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5A1E2A",
    d: "M15.266 22.718H.651a.65.65 0 0 1-.651-.65c0-6.223 3.618-11.36 7.959-11.36s7.958 5.065 7.958 11.36c0 .36-.29.65-.651.65M1.302 21.416h13.313c-.217-5.21-3.111-9.333-6.656-9.333-3.546 0-6.44 4.124-6.657 9.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A1E2A",
    d: "M7.959 12.01C3.545 12.01 0 6.946 0 .651 0 .29.29 0 .651 0h14.687c.362 0 .652.29.652.651-.073 6.295-3.618 11.36-8.031 11.36M1.302 1.302c.217 5.21 3.111 9.334 6.657 9.334s6.439-4.124 6.656-9.334z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A1E2A",
    d: "M13.385 7.67c-5.571-3.98-10.636-.146-10.853 0l-.362-.507c.073-.073 5.644-4.27 11.577 0zM15.121 19.535c-7.307-5.21-14.036-.217-14.325 0l-.434-.507c.072-.072 7.38-5.57 15.121 0z"
  })));
};
export default SvgTime;